import ctlCommonUtils from '../../jsCom/goForm/components/Common_Utils';
import {AssertUtils, GoingUtils} from "goingutils";

function _getTreeHeight(vueObj,ztreeObj) {

    //表示单表通过layout激活的 否则表示单表通过div自身激活的。
    let pHeight =
        parseFloat(
            $(ztreeObj)
                .parent()
                .css("height")
        ) - 6;

    $(ztreeObj).css("height", pHeight);
    //如果存在标题区域
    if (vueObj.headerText) {
        pHeight =
            pHeight -
            parseFloat(
                $(ztreeObj)
                    .find(".dhx_cell_hdr")
                    .css("height")
            ) -
            2;
    }
    //如果存在查询则高度还需要减去查询的高度
    if (vueObj.hasSearch) {
        pHeight = pHeight - 33;
    }
    if (vueObj.bottomHeight > 0) {
        pHeight = pHeight - vueObj.bottomHeight;
    }
    return pHeight;
}
function _getHasHeightParent(elObj,parentJson){
    let parentNode=$(elObj).parent();

    if(parentNode!=null&&parentNode.get(0)!=null&&parentJson["parentNode"]==null){
        let pHeight = parseFloat(parentNode.css("height"));
        if(pHeight<=50){
            _getHasHeightParent(parentNode.parent(),parentJson);
        }else{
            parentJson.$parentNode=parentNode;
        }
    }else{
        return void(0);
    }

}

let _getGridWidAndHeight = function (
    ctlId,
    hasPagin,
    topHeight,
    hasToolBar,
    padding=0
) {
    let parentJson={$parentNode:null};
    _getHasHeightParent($("#" + ctlId),parentJson);
    let pHeight = 0;
    var pWid = 0;
    if(parentJson.$parentNode!=null){
        pHeight = parseFloat(parentJson.$parentNode.css("height"));
        pWid = parseFloat(parentJson.$parentNode.css("width"));
    }

    //如果存在Tabset
    if (ctlCommonUtils.hasTabset(ctlId)) {
        pHeight = pHeight - ctlCommonUtils.getTabsetHeight();
    }

    //如果存在查询区域
    if (ctlCommonUtils.hasQueryArea(ctlId)) {
        pHeight = pHeight - ctlCommonUtils.getQueryAreaHeight();
    }

    //如果存在分页栏
    if (ctlCommonUtils.hasPagin(ctlId) || hasPagin) {
        pHeight = pHeight - GoingUtils.paginHeight;
    }

    // //如果存在工具栏，这个由用户自己控制
    if (hasToolBar && ctlCommonUtils.hasToolBar(ctlId)) {
        pHeight = pHeight - ctlCommonUtils.getToolBarHeight();
    }

    //如果用户传人了顶部间距
    if (AssertUtils.isNumber(topHeight) && topHeight != 0) {
        pHeight = pHeight - topHeight;
    }
    //传人一个固定修正值
    pHeight = pHeight - 9;
    //如果传入了左右间距
    if (AssertUtils.isNumber(padding) && padding>0) {
        pWid = pWid - padding*2;
    }
    return {pWid, pHeight};
};

export {_getTreeHeight, _getGridWidAndHeight};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/commonFun/CommonFun.js